import { Text } from '@chakra-ui/react';

export const Txt = Text;